import { Map, List } from "immutable";
import isInternalOrExternalNote from "MODULES/shared/components/Notes/isInternalOrExternalNote";

import * as actionTypes from "./actionTypes";

//
// Notes
//
const noteStateKey = action => {
  if (isInternalOrExternalNote(action.notesType)) {
    return `${action.notesType}_note`;
  }

  return "notes";
};

const getNotes = (state, action) =>
  state.merge({ [noteStateKey(action)]: List(), notesLoading: true });

const setNotes = (state, action) =>
  state.merge({ [noteStateKey(action)]: action.notes, notesLoading: false });

const addNote = (state, action) => {
  const note = Map().merge(action.note);
  const notesKey = noteStateKey(action);
  const notes = state.get(notesKey).unshift(note);
  return state.merge({ [notesKey]: notes });
};

const updateNote = (state, action) => {
  const notesKey = noteStateKey(action);
  const notes = state.get(notesKey);
  const updatedNotes = notes.map(note => {
    if (note.get("id") === action.note.id) {
      return note.merge(action.note);
    }
    return note;
  });

  return state.merge({ [notesKey]: updatedNotes });
};

const removeNote = (state, action) => {
  const notesKey = noteStateKey(action);
  const updatedNotes = state
    .get(notesKey)
    .filter(note => note.get("id") !== action.id);
  return state.merge({ [notesKey]: updatedNotes });
};

export function createNoteReducer(resource) {
  const actionType = t => `${t}_${resource}`;
  return {
    [actionType(actionTypes.ADD_NOTE)]: addNote,
    [actionType(actionTypes.GET_NOTES)]: getNotes,
    [actionType(actionTypes.SET_NOTES)]: setNotes,
    [actionType(actionTypes.UPDATE_NOTE)]: updateNote,
    [actionType(actionTypes.REMOVE_NOTE)]: removeNote
  };
}

export const notesInitialState = Map({
  notes: List(),
  internal_notes: List(),
  external_notes: List(),
  notesLoading: false
});

//
// Attachments
//
const getAttachments = state =>
  state.merge({ attachments: List(), attachmentsLoading: true });

const setAttachments = (state, action) =>
  state.merge({ attachments: action.attachments, attachmentsLoading: false });

const addAttachment = (state, action) => {
  const attachment = Map().merge(action.attachment);
  const attachments = state.get("attachments").push(attachment);
  return state.merge({ attachments });
};

const updateAttachment = (state, action) => {
  const attachments = state.get("attachments");
  const updatedAttachments = attachments.map(attachment => {
    if (attachment.get("id") === action.attachment.id) {
      return attachment.merge(action.attachment);
    }
    return attachment;
  });

  return state.merge({ attachments: updatedAttachments });
};

const removeAttachment = (state, action) => {
  const updatedAttachments = state
    .get("attachments")
    .filter(attachment => attachment.get("id") !== action.id);
  return state.merge({ attachments: updatedAttachments });
};

export function createAttachmentReducer(resource) {
  const actionType = t => `${t}_${resource}`;
  return {
    [actionType(actionTypes.ADD_ATTACHMENT)]: addAttachment,
    [actionType(actionTypes.GET_ATTACHMENTS)]: getAttachments,
    [actionType(actionTypes.SET_ATTACHMENTS)]: setAttachments,
    [actionType(actionTypes.UPDATE_ATTACHMENT)]: updateAttachment,
    [actionType(actionTypes.REMOVE_ATTACHMENT)]: removeAttachment
  };
}

export const attachmentsInitialState = Map({
  attachments: List(),
  attachmentsLoading: false
});



// WEBPACK FOOTER //
// ./app/modules/shared/reducer.js